import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { catchError, map, of } from 'rxjs';
import { canManageBufferStock } from '../Models/bufferstock.model';
import { LoginService } from '../Services/login.service';

export const bufferStockGuard: CanActivateFn = () => {
    const loginService = inject(LoginService);
    const router = inject(Router);
    const toastr = inject(ToastrService);

    return loginService.getCurrentUser().pipe(
        map((user) => {
            if (canManageBufferStock(user)) return true;
            toastr.warning('Buffer stock is not available for your company.');
            return router.createUrlTree(['/home']);
        }),
        catchError((error: unknown) => {
            console.error('Unable to verify buffer-stock access:', error);
            toastr.error('Unable to verify buffer-stock access. Please log in again.');
            return of(router.createUrlTree(['/login']));
        }),
    );
};
